import React, { useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ManageUserProfileFormPage } from '../../pages/ManageUser';
import { getNetworkStatus, getUserMasterData } from '../../../selectors/selector';
import { getSelectedManageUser } from '../../../selectors/Manage/selector';
import { showNetworkAlert } from '../../../actions/App/action';
import { editUserDetails, removeUserDetails } from '../../../actions/manage/action';
import { handleDelink, handleUpdateSubmit } from './ManageUserUtil';
import { Prompt } from 'react-router';

export const ManageUserProfileEditContainer: React.FC<any> = (props: any) => {
  
  const [submitNav, setSubmitNav] = useState<boolean>(true);

  return (
    <>
       <Prompt
          when={props.submitable && submitNav}
          message="Are you sure you want to navigate? Form data will get lost."
      />
      <ManageUserProfileFormPage
        {...props}
        selectedUser={props.history?.location?.state?.selectedUser}
        handleSubmit={handleUpdateSubmit(props)}
        handleDelink={handleDelink({...props})}
        module="manage/ManageUser/Profile"
        setSubmitNavFlag={() => setSubmitNav(false)}
      />
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  userDetails: getUserMasterData(),
  selectedUser: getSelectedManageUser(),
  isNetworkAvailable: getNetworkStatus(),
  userDetailsNew: getUserMasterData(),
});

export const mapDispatchToProps = (dispatch: Function) => ({
  showNetworkAlert: () => dispatch(showNetworkAlert()),
  updateUserAction: (payload: any) => dispatch(editUserDetails(payload)),
  delinkUserAction: (payload: any) => dispatch(removeUserDetails(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageUserProfileEditContainer);
